export default __webpack_public_path__ + "static/mainimg-6f33c47dfba133c23409e349abbe3185.svg";